import $ from 'jquery';
import fitvids from 'fitvids';

export default class RTE {
  constructor(section) {
    this.$el = $(section.el);

    this.setupTabs();

    const selects = this.$el.find('select');

    for (let i = 0; i < selects.length; i++) {
      const select = selects[i];

      if (!$(select).parent('.select-wrapper').length) {
        $(select).wrap('<div class="select-wrapper" />').parent().prepend('<span class="selected-text"></span>');
      }

      this.updateOption(null, select);
    }

    fitvids('.rte');
    this._bindEvents();
  }

  _bindEvents() {
    $('.tabs li', this.$el).on('click', (event) => this.switchTabs(event));
    $('.select-wrapper select', this.$el).on('change', (event) => this.updateOption(event));
  }

  switchTabs(event) {
    event.preventDefault();

    const tab = $(event.currentTarget);
    const position = tab.index();

    this.tabs.removeClass('active');
    this.tabsContent.removeClass('active');

    tab.addClass('active');
    this.tabsContent.eq(position).addClass('active');
  }

  setupTabs() {
    this.tabs = $('.tabs > li', this.$el);
    this.tabsContent = $('.tabs-content > li', this.$el);

    this.tabs.first().addClass('active');
    this.tabsContent.first().addClass('active');
  }

  updateOption(event, selector) {
    const select = event ? $(event.target) : $(selector);
    const newOption = select.find('option:selected').text();

    select.siblings('.selected-text').text(newOption);
  }
}
